import { render, staticRenderFns } from "./BetPerResultLast5Games.vue?vue&type=template&id=c098cad8&scoped=true&"
import script from "./BetPerResultLast5Games.vue?vue&type=script&lang=js&"
export * from "./BetPerResultLast5Games.vue?vue&type=script&lang=js&"
import style0 from "./BetPerResultLast5Games.vue?vue&type=style&index=0&id=c098cad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c098cad8",
  null
  
)

export default component.exports